import store from '../../store'
export const web_hook_on_invite = (session)=>{
  store.dispatch("phone/receiveCall",session);
}
export const web_hook_on_modify = (type,session) =>{
  if(type == 'accepted'){
    store.dispatch('phone/acceptedTheCall',session)
  }
}
export const web_hook_handle_audio_stream =(obj)=>{
  store.dispatch('stt/handleAudioStream',obj);
}

export const web_hook_set_stt_end_time = () => {
  store.dispatch('stt/setSttEndTime')
}
export const web_hook_on_terminate =(session) =>{
  store.dispatch('phone/terminateTheCall',session);
}
export const web_hook_on_lines_update = (lines) =>{
  store.commit('phone/updateLineList',lines);
}

export const web_hook_update_buddies = (buddies) => {
  store.dispatch('phone/updateBuddies', JSON.parse(buddies))
}
export const web_hook_on_register = () => {
  store.commit('phone/setRegisterStatus', 'registered')
}
export const web_hook_on_unregistered = () =>{
  store.commit('phone/setRegisterStatus', 'unregistered')
}
export const web_hook_on_transportError = () => {
  store.commit('phone/setRegisterStatus', 'registerError')
}
export const web_hook_on_transportDisconnected = ()=> {
  store.commit('phone/setRegisterStatus', 'disconnected')
}
export const web_hook_on_call_info = (telNum) => {
  store.dispatch('phone/setOnCallInfo', telNum)
}

export const web_hook_get_current_issue_id = () => {
  return store.state.phone.redmineIssueId || ''
}
